<ng-template #giftModal let-modal>
    <div class="modal-content" *ngIf="selectedGift">
        <div class="modal-header" style="border-bottom: 1px solid #DEDEDE; padding: 25px;">
            <div class="d-flex justify-content-between align-items-center w-100">
                <div *ngIf="!isExchanged" class="modal-title" style="font-size: 24px;">Đổi quà</div>
                <div *ngIf="isExchanged" class="modal-title" style="font-size: 24px;">Chi tiết quà</div>
                <app-button [class]="'btn btn-close btn-sm'" [spinner]="false" [id]="'login_modal_close_btn'"
                    (click)="modal.dismiss('Cancel')">
                    <i class="ri-close-line"></i>
                </app-button>
            </div>
        </div>
        <div class="modal-body p-0">
            <div style="padding: 32px 25px;">
                <div class="d-flex align-items-center gap-2" style="padding-bottom: 20px;">
                    <img src="assets/svg/gift/gift.svg"  loading="lazy" />
                    <span style="font-size: 20px; font-weight: 600;">Quà đã chọn</span>
                </div>

                <div style="margin-bottom: 24px; border: 1px solid #059F00; border-radius: 8px;">
                    <div class="d-flex align-items-center" style="padding: 24px; gap: 24px;">
                        <div style="max-width: 140px; max-height: 140px; overflow: hidden;">
                            <img class="img-fluid" [src]="selectedGift.imageUrls?.[0]"  loading="lazy" />
                        </div>
                        <div>
                            <div style="color: #222222; font-size: 16px; font-weight: 600;">{{ selectedGift.name }}</div>
                            <div style="color: #808080; font-size: 12px;">Số lượng còn lại: {{ selectedGift.remainingQuantity > 999999 ? 'Không giới hạn' : selectedGift.remainingQuantity }}</div>
                            <div style="color: var(--theme-color); font-size: 18px; font-weight: 600;">{{ selectedGift.cost | currencySymbol: false }} xu</div>
                            <ng-container *ngIf="!isExchanged">
                                <div class="cart_qty qty-box open position-relative">
                                    <div class="input-group">
                                        <app-counter
                                        style="width: 100%"
                                        [selectedGift]="selectedGift"
                                        [isGift]="true"
                                        (quantityError)="onQuantityError()">
                                        </app-counter>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="d-flex align-items-center gap-2" style="padding-bottom: 14px;">
                    <img src="assets/svg/gift/document.svg"  loading="lazy" />
                    <span style="font-size: 20px; font-weight: 600;">Mô tả:</span>
                </div>

                <div style="font-size: 16px; color: #707070; margin-bottom: 32px;" [innerHTML]="selectedGift.description"></div>

                <ng-container *ngIf="!isExchanged">
                    <div class="d-flex align-items-center gap-2" style="padding-bottom: 32px;">
                        <img src="assets/svg/gift/coin-icon.svg"  loading="lazy" />
                        <span style="font-size: 20px; font-weight: 600;">Xu hiện có: </span>
                        <span style="font-size: 20px; font-weight: 600; color: var(--theme-color);">{{ balance | currencySymbol: false }} xu</span>
                    </div>

                    <div class="d-flex align-items-center gap-1">
                        <input class="checkbox_animated" type="checkbox" [checked]="agreed" (click)="agree()" />
                        <span style="color: #707070; font-size: 16px; margin-top: 6px;">Tôi hiểu rằng quà đã đổi sẽ không thể hoàn lại.</span>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="modal-footer p-0" *ngIf="!isExchanged">
            <div class="w-100 d-flex justify-content-center" style="padding: 0 0 24px; gap: 20px;">
                <button type="button" class="border-0 rounded-3" style="width: 120px; height: 40px;" (click)="modal.dismiss('Cancel')">
                    <span style="font-size: 16px;">Hủy</span>
                </button>
                <button debounce="300" type="button" class="border-0 rounded-3" style="width: 120px; height: 40px; background-color: var(--theme-color);" [disabled]="!agreed" (debounceClick)="confirmExchange();">
                    <span style="font-size: 16px; color: #fff;">Đổi quà</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>